export default "__VITE_ASSET__BBAZSWYJ__"